import { Analytics, checkPlacement } from 'client/Global/Analytics'
import { trackingFields } from 'client/Global/AnalyticsEvents'
import { SubscriptionFeatureCheckboxType } from 'client/Interfaces/Subscription/ISubscriptionFeatureList'
import { l } from 'client/Other/Translation'
import { setBaseClass } from 'client/utils'
import * as React from 'react'
import Checkmark from 'static/images/premiumPlans/checkmark/checkmark_green.svg'

import { ISubscriptionPremiumPlanOptionsPropsInterface } from '../IPremiumInterface'
import './FeatureList.scss'

interface TInvoiceQuotaMultiplePlansSelect {
  selectedPlanName: ISubscriptionPremiumPlanOptionsPropsInterface['selectedPlanName']
  onSelectCombinedPlan: ISubscriptionPremiumPlanOptionsPropsInterface['onSelectCombinedPlan']
  selectableAvailablePlans: ISubscriptionPremiumPlanOptionsPropsInterface['selectableAvailablePlans']
  billingCycle: 'month' | 'year'
  allPlans
}

const cls = setBaseClass('SubscriptionFeatureList')

const InvoiceQuotaMultiplePlanSelectOption = ({ name, quota }: { name: string; quota: string }) => {
  return (
    <option value={name} key={name}>
      {name !== 'plan.contact_us' ? `${quota}` : `${quota}+`}
    </option>
  )
}

const InvoiceQuotaMultiplePlanSelect = (props: TInvoiceQuotaMultiplePlansSelect) => {
  const { selectedPlanName, onSelectCombinedPlan, selectableAvailablePlans, billingCycle, allPlans } = props

  const asteriskElement =
    billingCycle === 'year' ? (
      <div className={cls('__text_invoices_pro_dropdown')}>{l('subscription.premium_invoices_per_year_growth')}</div>
    ) : (
      <div className={cls('__text_invoices_pro_dropdown')}>{l('subscription.premium_invoices_per_month_growth')}</div>
    )

  if (billingCycle === 'year' && selectableAvailablePlans[0] && selectableAvailablePlans[0].name === 'plan.growth') {
    selectableAvailablePlans[0].quota = 360
  }
  if (
    billingCycle === 'year' &&
    selectableAvailablePlans[1] &&
    selectableAvailablePlans[1].name === 'plan.contact_us'
  ) {
    selectableAvailablePlans[1].quota = 1200
  }

  return (
    <div className={cls('__invoice-quota-multiple-plan_wrapper')}>
      <img
        className={cls({
          __checkmark: true,
          ...{
            '--checkmark-green': SubscriptionFeatureCheckboxType.GREEN,
          },
        })}
        src={Checkmark}
      />
      <select
        value={selectedPlanName}
        onChange={(e) => {
          onSelectCombinedPlan(e.target.value)
          Analytics.trackEvent(trackingFields.name.changeGrowthQuota, {
            type: trackingFields.type.action,
            category: trackingFields.category.subscription,
            result: trackingFields.result.success,
            placement: checkPlacement(window.location.pathname),
            selectedQuota: e.target.value,
          })
        }}
        onClick={() => {
          Analytics.trackEvent(trackingFields.name.changeGrowthQuota, {
            type: trackingFields.type.action,
            category: trackingFields.category.subscription,
            result: trackingFields.result.click,
            placement: checkPlacement(window.location.pathname),
          })
        }}
        className={cls('__invoice-quota-multiple-plan')}
      >
        {selectableAvailablePlans.map(({ name, quota }: { name: string; quota: string }) => (
          <InvoiceQuotaMultiplePlanSelectOption name={name} quota={quota} key={name} />
        ))}
      </select>
      {asteriskElement}
    </div>
  )
}

export default InvoiceQuotaMultiplePlanSelect
